var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGlasses = function SvgGlasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "M6.2 1c-.348 0-.521 0-.672.011-1.77.136-3.225 1.438-3.538 3.167a9 9 0 0 0-.078.66l-.885 8.493m10.373.526h5.2m-5.2 0C11.4 16.697 9.072 19 6.2 19S1 16.697 1 13.857s2.328-5.143 5.2-5.143 5.2 2.303 5.2 5.143m5.2 0c0 2.84 2.328 5.143 5.2 5.143s5.2-2.303 5.2-5.143-2.328-5.143-5.2-5.143-5.2 2.303-5.2 5.143M21.82 1c.347 0 .52 0 .67.011a3.884 3.884 0 0 1 3.54 3.167c.026.147.043.318.078.66l.866 8.507"
  })));
};
export default SvgGlasses;